import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  GET_ALL_SLIDERS,
  GET_HOME_TRACK_PROFILE,
  GET_HOME_GETTING_STARTED,
  GET_HOME_DETAIL_INFO,
  GET_HOME_SECTION_INFO,
  GET_NECS
} from "../utils/api-url";

export default class Home extends Base {
  constructor(params = {}) {
    super(params);
  }

  static getAllSliders() {
    return apiDispatcher(GET_ALL_SLIDERS());
  }

  static getHomeTrackProfile() {
    return apiDispatcher(GET_HOME_TRACK_PROFILE());
  }

  static getHomeGettingStarted() {
    return apiDispatcher(GET_HOME_GETTING_STARTED());
  }

  static getHomeDetailInfo() {
    return apiDispatcher(GET_HOME_DETAIL_INFO());
  }

  static getHomeSectionInfo() {
    return apiDispatcher(GET_HOME_SECTION_INFO());
  }

  static getNecs() {
    return apiDispatcher(GET_NECS());
  }
}
